/*
 * wysiwyg web editor
 *
 * suneditor.js
 * Copyright 2017 JiHong Lee.
 * MIT license.
 */

(function (global, factory) {
    if (typeof module === 'object' && typeof module.exports === 'object') {
        module.exports = global.document ?
            factory(global, true) :
            function (w) {
                if (!w.document) {
                    throw new Error('SUNEDITOR_LANG a window with a document');
                }
                return factory(w);
            };
    } else {
        factory(global);
    }
}(typeof window !== 'undefined' ? window : this, function (window, noGlobal) {
    const lang = {
        toolbar: {
            default: 'Padrão',
            save: 'Salvar',
            font: 'Fonte',
            formats: 'Formatos',
            fontSize: 'Tamanho',
            bold: 'Negrito',
            underline: 'Sublinhado',
            italic: 'Itálico',
            strike: 'Tachado',
            subscript: 'Subscrito',
            superscript: 'Sobrescrito',
            removeFormat: 'Remover Formatação',
            fontColor: 'Cor da Fonte',
            hiliteColor: 'Cor de Destaque',
            indent: 'Avançar',
            outdent: 'Recuar',
            align: 'Alinhar',
            alignLeft: 'Esquerda',
            alignRight: 'Direita',
            alignCenter: 'Centro',
            alignJustify: 'Justificado',
            list: 'Lista',
            orderList: 'Lista Ordenada',
            unorderList: 'Lista Não Ordenada',
            horizontalRule: 'Linha Horizontal',
            hr_solid: 'Sólido',
            hr_dotted: 'Pontilhado',
            hr_dashed: 'Tracejado',
            table: 'Tabela',
            link: 'Link',
            image: 'Imagem',
            video: 'Vídeo',
            fullScreen: 'Tela Cheia',
            showBlocks: 'Mostrar Blocos',
            codeView: 'Visualizar Código',
            undo: 'Desfazer',
            redo: 'Refazer',
            preview: 'Pré-visualizar',
            print: 'Imprimir',
            tag_p: 'Parágrafo',
            tag_div: 'Normal (DIV)',
            tag_h: 'Cabeçalho',
            tag_blockquote: 'Citação',
            tag_pre: 'Código',
            template: 'Modelo',
            lineHeight: 'Altura da Linha'
        },
        dialogBox: {
            linkBox: {
                title: 'Inserir Link',
                url: 'URL do link',
                text: 'Texto mostrado',
                newWindowCheck: 'Abrir em nova janela'
            },
            imageBox: {
                title: 'Inserir Imagem',
                file: 'Selecionar de Arquivos',
                url: 'URL da Imagem',
                altText: 'Texto alternativo'
            },
            videoBox: {
                title: 'Inserir Vídeo',
                url: 'URL para incorporar mídia, YouTube'
            },
            caption: 'Inserir descrição',
            close: 'Fechar',
            submitButton: 'Enviar',
            revertButton: 'Reverter',
            proportion: 'Restringir proporções',
            width: 'Largura',
            height: 'Altura',
            basic: 'Básico',
            left: 'Esquerda',
            right: 'Direita',
            center: 'Centro'
        },
        controller: {
            edit: 'Editar',
            remove: 'Remover',
            insertRowAbove: 'Inserir linha acima',
            insertRowBelow: 'Inserir linha abaixo',
            deleteRow: 'Apagar linha',
            insertColumnBefore: 'Inserir coluna antes',
            insertColumnAfter: 'Inserir coluna depois',
            deleteColumn: 'Apagar coluna',
            resize100: 'Redimensionar 100%',
            resize75: 'Redimensionar 75%',
            resize50: 'Redimensionar 50%',
            resize25: 'Redimensionar 25%',
            mirrorHorizontal: 'Inverter, Horizontal',
            mirrorVertical: 'Inverter, Vertical',
            rotateLeft: 'Girar à esquerda',
            rotateRight: 'Girar à direita',
            maxSize: 'Tamanho Máximo',
            minSize: 'Tamanho Mínimo',
            tableHeader: 'Cabeçalho da Tabela',
            mergeCells: 'Fundir células',
            splitCells: 'Separar células',
            HorizontalSplit: 'Separar Horizontal',
            VerticalSplit: 'Separar Vertical'
        }
    };

    if (typeof noGlobal === typeof undefined) {
        if (!window.SUNEDITOR_LANG) {
            window.SUNEDITOR_LANG = {};
        }

        window.SUNEDITOR_LANG.ptBR = lang;
    }

    return lang;
}));